<template>
  <div class="sidebar" :class="{ open }" v-if="user">
    <div class="sidebar-logo"><logo/></div>
    <ul>
      <li>
        <router-link to="/" @click="close()"><i class="fa-solid fa-dashboard"></i> Dashboard</router-link>
      </li>

      <li v-if="pages.user">
        <router-link to="/users" @click="close()"><i class="fa-solid fa-user-lock"></i> Quản lí users</router-link>
      </li>

      <li v-if="pages.team">
        <router-link to="/teams" @click="close()"><i class="fa-solid fa-people-group"></i> Quản lí teams</router-link>
      </li>

      <li v-if="pages.cpd">
        <router-link to="/cpds" @click="close()"><i class="bx bx-category"></i> Quản lí CPDs</router-link>
      </li>

      <li v-if="pages.docs">
        <router-link to="/docs" @click="close()"><i class='bx bxs-color'></i> Trợ giúp</router-link>
      </li>

      <!-- <li>
        <router-link to="/personal-info" @click="close()"><i class="fa-regular fa-address-card"></i> Personal
          info</router-link>
      </li>

      <li>
        <router-link to="/security" @click="close()"><i class="fa-solid fa-user-lock"></i> Security</router-link>
      </li> -->
    </ul>
    <div class="themes">
      <div class="des">Thay đổi theme</div>
      <div class="theme theme-white" :class="{active: theme == 'white'}" @click="applyTheme('white')"></div>
      <div class="theme theme-blue" :class="{active: theme == 'blue'}" @click="applyTheme('blue')"></div>
    </div>
  </div>
  <div class="overlay" @click="close(true)" v-if="open"></div>
</template>

<style lang="scss" scoped>
.overlay{
  display: none;
  @media screen and (max-width: 1023px) {
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba($color: #000000, $alpha: 0.5);
    z-index: 10;
  }
}
.sidebar {
  padding-top: 20px;
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 250px;
  background-color: var(--color-sidebar-bg);
  transition: 0.3s;
  z-index: 11;

  @media screen and (max-width: 1023px) {
    &:not(.open) {
      left: -250px;
    }
  }

  .sidebar-logo{
    padding-left: 39px;
    margin-bottom: 15px;
  }

  ul {
    list-style: none;
    padding: 0;

    li {
      padding: 0 15px;
      
      a {
        padding: 0.75rem 0.75rem 0.75rem 1.5rem;
        display: block;

        &.active {
          background-color: var(--color-container-border);
          color: var(--color-page-menu-border-active);
          // border-top-right-radius: 30px;
          // border-bottom-right-radius: 30px;
          border-radius: 30px;
        }
      }
    }
  }
}

.themes{
  position: absolute;
  width: 100%;
  bottom: 0;
  left: 0;
  padding: 1rem;
  text-align: center;
  .des{
    font-size: 0.75rem;
    margin-bottom: 4px;
    color: var(--color-body-text-hover);
  }

  .theme {
    height: 20px;
    width: 20px;
    display: inline-block;
    border: 2px solid var(--color-container-border);
    margin: 3px;
    cursor: pointer;

    &.theme-white {
      background-color: #ffffff;
    }

    &.theme-blue {
      background-color: #0c1c2b;
    }

    &.active{
      border-color: var(--color-active) !important;
    }
  }
}
</style>

<script>
export default {
  props: ['open'],

  computed: {
    user(){
      return this.$store.state.auth.user;
    },

    pages() {
      return this.$store.state.auth.pages;
    },

    theme(){
      return this.$store.state.theme;
    }
  },
  
  methods: {
    close(w){
      if (w) {
        this.$emit('close');
        return;
      }

      let width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
      if (width <= 1023) this.$emit('close');
    },

    applyTheme(theme){
      this.$store.dispatch('theme', theme);
    }
  },

  mounted(){
    let theme = this.$route.query.theme;
    if (theme !== 'white' && theme !== 'blue') theme = null;
    this.applyTheme(theme);
  }
}
</script>